(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("axios"), require("babel-polyfill"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "axios", "babel-polyfill"], factory);
	else if(typeof exports === 'object')
		exports["platform-login"] = factory(require("react"), require("react-dom"), require("axios"), require("babel-polyfill"));
	else
		root["platform-login"] = factory(root["React"], root["ReactDOM"], root["axios"], root["babel-polyfill"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__74__, __WEBPACK_EXTERNAL_MODULE__547__) {
return 